import React from 'react';
import LinkButton from '@active/react-ui/LinkButton';
import GridItem from '@active/react-ui/GridItem';
import Locale from '@active/react-utils/i18n/Locale';
import pubSubInstance from '../../../../shared/utils/pubSub';

export const CheckImageButton = () => {
  const setShowImageModal = () => {
    pubSubInstance.dispatch('check-scanner-show-image-modal', true);
  };
  return <GridItem span={12} spanXl={4} style={{ paddingTop: '30px' }}>
    <LinkButton onClick={setShowImageModal} >
      <i className="ic-image" />
      <Locale id="checkout.lib.components.payment.check.checkImg" />
    </LinkButton>
  </GridItem>;
};
